import React, { PropsWithChildren, ReactNode } from 'react';
import { X } from 'lucide-react';
import Base from './Base';

type ModalProps = PropsWithChildren<{
  open: boolean;
  size?: 'S' | 'M' | 'L';
  title?: ReactNode;
  label?: ReactNode;
  /**
   * Whether the modal can be closed by clicking outside or pressing escape.
   * Default: true
   */
  dismissible?: boolean;
  showClose?: boolean;
  onClose: () => void;
}>;

export const Modal = (props: ModalProps) => {
  const {
    open,
    size = 'M',
    children,
    title,
    label,
    showClose = true,
    dismissible = true,
    onClose,
  } = props;

  return (
    <Base
      isOpen={open}
      onRequestClose={dismissible ? onClose : () => {}}
      size={size}
    >
      <div className="flex flex-col gap-s p-xxl mobile:p-l">
        <div className="flex items-center">
          {label}
          {showClose && (
            <button className="ml-auto" onClick={onClose}>
              <X className="size-m" />
            </button>
          )}
        </div>
        {Boolean(title) && <h3 className="font-heading text-h3">{title}</h3>}
        {children}
      </div>
    </Base>
  );
};
